"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCIES = void 0;
/* Currencies for the countries where Pleo operates */
exports.CURRENCIES = ['DKK', 'SEK', 'EUR', 'GBP', 'NOK', 'USD'];
//# sourceMappingURL=currencies.js.map